/**
 * Ticket KN1: Suchmaschinen- und Teilen-Angaben der Keynote-Seite.
 *
 * Derselbe Weg wie bei den Freebie-Landingpages (Ticket LM11) und den
 * Mentorings: eigener Titel, eigene Beschreibung, Vorschaubild über
 * `shareImageMeta`. Ohne Bild bleibt es bei der kleinen Kartenform – ein
 * Platzhalter sieht in einer Vorschau schlechter aus als keiner.
 */

import { shareImageMeta, type ShareMetaEntry } from "@/lib/share-image-meta";

export const KEYNOTE_SEO_TITLE = "Keynotes zu politischer Kommunikation | creategy";
export const KEYNOTE_SEO_DESCRIPTION =
  "Vorträge zu Krisenkommunikation, Wahlkämpfen, Desinformation und Kommunikation im Amt, mit einem ehemaligen Regierungssprecher und Kampagnenfachleuten.";

export type KeynoteHeadMetaEntry = { title: string } | ShareMetaEntry;

export function keynoteHeadMeta(shareImageUrl: string | null): KeynoteHeadMetaEntry[] {
  return [
    { title: KEYNOTE_SEO_TITLE },
    { name: "description", content: KEYNOTE_SEO_DESCRIPTION },
    { property: "og:title", content: KEYNOTE_SEO_TITLE },
    { property: "og:description", content: KEYNOTE_SEO_DESCRIPTION },
    { property: "og:type", content: "website" },
    ...shareImageMeta(shareImageUrl),
  ];
}
